import { useAuth } from "@/contexts/AuthContext";
import { ROLE_LABELS } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { LogOut, Mail, Phone, MapPin, UserCircle } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  const doLogout = async () => { await logout(); nav("/login"); };
  return (
    <div className="space-y-6" data-testid="profile-page">
      <div className="bg-white rounded-xl border border-slate-200 p-6 text-center">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#001F54] text-white grid place-items-center text-3xl font-black">
          {user.name?.[0]}
        </div>
        <h1 className="mt-4 text-2xl font-heading font-black">{user.name}</h1>
        <div className="text-sm text-slate-500">{ROLE_LABELS[user.role]}</div>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
        <Item icon={Mail} label="Email" value={user.email} />
        <Item icon={Phone} label="Phone" value={user.phone || "—"} />
        <Item icon={MapPin} label="Assigned States" value={(user.assigned_states || []).join(", ") || "—"} />
        <Item icon={UserCircle} label="Sales Target" value={user.sales_target ? `$${Number(user.sales_target).toLocaleString()}` : "—"} />
      </div>
      <button onClick={doLogout} className="w-full h-12 rounded-lg border border-slate-300 font-semibold flex items-center justify-center gap-2 hover:border-[#003DA5] hover:text-[#003DA5] transition" data-testid="profile-logout-btn">
        <LogOut className="w-4 h-4" /> Log out
      </button>
    </div>
  );
}
const Item = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-4 p-4">
    <div className="w-9 h-9 rounded-full bg-slate-100 grid place-items-center"><Icon className="w-4 h-4 text-slate-500" /></div>
    <div className="flex-1">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className="text-sm font-medium">{value}</div>
    </div>
  </div>
);
